import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LookupModel } from '../../../../api/models/lookup-model';
import { EVENT_FLOW_FIELD_LABELS } from '../../node-parameters/constants/event-flow-field-labels.const';
import { NgIf } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSimpleSelectComponent } from '../../../../editors/mat-simple-select/mat-simple-select.component';
import { HhaNoteTemplateComponent } from '../hha-note-template/hha-note-template.component';

@Component({
    selector: 'events-flow-hha-patient-notes-settings',
    templateUrl: './hha-patient-notes-settings.component.html',
    styleUrls: ['./hha-patient-notes-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        FlexModule,
        MatProgressSpinner,
        FormsModule,
        ReactiveFormsModule,
        MatSimpleSelectComponent,
        HhaNoteTemplateComponent,
    ],
})
export class EventsFlowHhaPatientNotesSettingsComponent {
  @Input({ required: true })
  actionItemFormGroup!: FormGroup;

  @Input({ required: true })
  patientNotes!: LookupModel[];

  public readonly fieldLabels = EVENT_FLOW_FIELD_LABELS;

  get templateNoteFormControl(): FormControl {
    return this.actionItemFormGroup.get('noteTemplate') as FormControl;
  }
}
